import { render, staticRenderFns } from "./nickname.vue?vue&type=template&id=2ee56409&scoped=true&"
import script from "./nickname.vue?vue&type=script&lang=js&"
export * from "./nickname.vue?vue&type=script&lang=js&"
import style0 from "./nickname.vue?vue&type=style&index=0&id=2ee56409&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee56409",
  null
  
)

export default component.exports